import { CalendarLinesPen } from '../../../assets/icons/CalendarLinesPen';
import { Coins } from '../../../assets/icons/Coins';
import { ScrewdriverWrench } from '../../../assets/icons/ScrewdriverWrench';
import { ShieldCheck } from '../../../assets/icons/ShieldCheck';
import { CoverageBenefitsPanelArticles } from '../components/CoverageBenefitsPanel/CoverageBenefitsPanel';

export const coverageBenefitsPanelArticles: CoverageBenefitsPanelArticles[] = [
  {
    icon: ScrewdriverWrench(),
    description: 'Accidental damage and breakdown coverage',
    additionalDescription: '(broken parts, mechanical issues)',
  },
  {
    icon: ShieldCheck(),
    description: "New appliance if it can't be fixed",
  },
  {
    icon: Coins(),
    description: 'No deductibles',
  },
  {
    icon: CalendarLinesPen(),
    description: 'Cancel anytime',
  },
];
